import type { HTMLAttributes } from 'react'

import clsx from 'clsx'
import { typo } from 'shared/styles'

import * as files from '../../utils/files'
import css from './PreviewFiles.module.scss'
export function ShortPreview({
	className,
	...props
}: HTMLAttributes<HTMLParagraphElement>) {
	const count = files.useIds().size

	if (count > 0) {
		return (
			<p className={clsx(className, css.short, typo.buttonSmB)} {...props}>
				{count} {count === 1 ? 'file' : 'files'} attached
			</p>
		)
	}
}
